import React, { useState, useEffect } from 'react';
import { Grid, Paper } from "@material-ui/core";
import { useLocation } from "react-router-dom";
import AccountDtls from "./AccountDtls";
import AccountViewHeader from "./AccountViewHeader";
import UseFetchData from "../../../hooks/UseFetchData";
import CreateContact from './CreateContact';
import RelatedData from "./RelatedData";
import ModalFrame from "../../biztran_controls/Modal_Frame";

const AccountMasterView = () => {
  const [ContactID, setContactID] = useState('');
  const [AccountID, setAccountID] = useState('')
  const [AccountName, setAccountName] = useState('');
  const [isOpen, setOpen] = useState(false);
  const [AccountMainData, setAccountMainData] = useState([]);
  const [AccountHeaderMailData, setAccountHeaderMailData] = useState([]);
  const [AccountNoteData, setAccountNoteData] = useState([]);
  const [AccountAttachData, setAccountAttachData] = useState([]);
  const [AccountImageData, setAccountImageData] = useState([]);
  const [AccountActivityData, setAccountActivityData] = useState([]);
  const [responseData, setresponseData] = useState([])
  const [ContactData, setContactData] = useState([]);
  const location = useLocation();
  const [response, fetchData] = UseFetchData();
  const [responseViewDtls, fetchViewDtls] = UseFetchData();

  const getViewDtlsData = () => {
    var bodyFormData = new FormData();
    bodyFormData.append("AccountID", location.state.AccountID);
    fetchViewDtls("Account/View", bodyFormData);
  }

  useEffect(() => {
    if (responseViewDtls.Main !== undefined && responseViewDtls.Main.length > 0) {
      setAccountMainData(responseViewDtls.Main);
      // setAccountHeaderMailData(responseViewDtls.Main);
    }
    if (responseViewDtls.AccountActivity !== undefined && responseViewDtls.AccountActivity.length > 0) {
      setAccountActivityData(responseViewDtls.AccountActivity);
    }
    if (responseViewDtls.AccountNotes !== undefined && responseViewDtls.AccountNotes.length > 0) {
      setAccountNoteData(responseViewDtls.AccountNotes);
    }
    if (responseViewDtls.AccountAttachments !== undefined && responseViewDtls.AccountAttachments.length > 0) {
      setAccountAttachData(responseViewDtls.AccountAttachments);
    }
  }, [responseViewDtls]);


  useEffect(() => {
    if (response.Contact !== undefined) {
      setContactData(response.Contact);
    }
  }, [response]);

  const getByIDData = (AccID) => {
    var bodyFormData = new FormData();
    bodyFormData.append("AccountID", location.state.AccountID);
    fetchData("Contact/List", bodyFormData);
  }

  useEffect(() => {
    setAccountID(location.state.AccountID);
    setAccountName(location.state.AccountName);
    getViewDtlsData();
  }, [location.state.AccountID]);

  useEffect(() => {
    if (response !== undefined && response.length > 0) {
      setresponseData(response);
    }
  }, [response]);

  return (
    <Paper>
      <AccountViewHeader
        AccountID={location.state.AccountID}
        AccountMainData={AccountMainData}
        // AccountHeaderMailData={AccountMainData}
        // getViewDtlsData={getViewDtlsData}
        PopulateData={getViewDtlsData}

      />
      <Grid container direction="row" >
        <Grid sm={8} xs={12}>
          <Paper elevation={3} style={{ height: '100%' }}>
            <AccountDtls
              AccountID={location.state.AccountID}
              AccountMainData={AccountMainData}
              // AccountHeaderMailData={AccountMainData}
              // getViewDtlsData={getViewDtlsData}
              PopulateData={getViewDtlsData}
            />
          </Paper>
        </Grid>
        <Grid sm={4} xs={12}>

          <Paper elevation={3}>
            <h2 style={{ textDecoration: 'underline', textDecorationColor: '#0096FF', textDecorationThickness: 5 }}>RELATED</h2>
            <RelatedData
              AccountID={location.state.AccountID}
              AccountName={location.state.AccountName}
              AccountMainData={AccountMainData}
              AccountNoteData={AccountNoteData}
              AccountAttachData={AccountAttachData}
              AccountImageData={AccountImageData}
              AccountActivityData={AccountActivityData}
              PopulateData={getViewDtlsData}
            />
          </Paper>

          <ModalFrame
            title="Add Contact"
            maxWidth="md"
            isOpen={isOpen}
            headerAlign="center"
            setOpen={setOpen}
          >
            <CreateContact
              AccountID={location.state.AccountID}
              AccountName={location.state.AccountName}
              ContactID={ContactID}
              getByIDData={getByIDData}
              setOpen={setOpen}
            />
          </ModalFrame>
        </Grid>
      </Grid>
    </Paper>
  );
};

export default AccountMasterView;
